
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const AgentNotFound: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-5xl mx-auto text-center">
        <h1 className="text-2xl font-bold mb-4">Agent Not Found</h1>
        <p className="mb-6">The agent you're looking for doesn't exist or has been removed.</p>
        <Button asChild>
          <Link to="/browse">Browse Agents</Link>
        </Button>
      </div>
    </div>
  );
};
